export const couponTransactionLabels = {
    id: 'COUPON_TRANSACTION.ID',
    createdDateTime: 'COUPON_TRANSACTION.CREATED_DATE_TIME',
    transactionType: 'COUPON_TRANSACTION.TRANSACTION_TYPE',
    transactionResult: 'COUPON_TRANSACTION.TRANSACTION_RESULT',
    clientRequestReference: 'COUPON_TRANSACTION.CLIENT_REQUEST_REFERENCE',
    smartsCouponTransactionReference: 'COUPON_TRANSACTION.SMARTS_COUPON_TRANSACTION_REFERENCE',
    partnerId: 'COUPON_TRANSACTION.PARTNER_ID',
    storeId: 'COUPON_TRANSACTION.STORE_ID',
    storeName: 'COUPON_TRANSACTION.STORE_NAME',
    storeRetailerRef: 'COUPON_TRANSACTION.STORE_RETAILER_REF',
    deviceId: 'COUPON_TRANSACTION.DEVICE_ID',
    deviceName: 'COUPON_TRANSACTION.DEVICE_NAME',
    operatorId: 'COUPON_TRANSACTION.OPERATOR_ID',
    ecrBasketId: 'COUPON_TRANSACTION.ECR_BASKET_ID',
    totalDiscountAmount: 'COUPON_TRANSACTION.TOTAL_DISCOUNT_AMOUNT',
    currency: 'COUPON_TRANSACTION.CURRENCY',
    errorCode: 'COUPON_TRANSACTION.ERROR_CODE',
    errorMessage: 'COUPON_TRANSACTION.ERROR_MESSAGE',
    'couponScheme.id': 'COUPON_SCHEME.ID',
    'couponScheme.schemeName': 'COUPON_SCHEME.SCHEME_NAME',
    'couponScheme.schemeType': 'COUPON_SCHEME.SCHEME_TYPE',
    'couponScheme.schemeStatus': 'COUPON_SCHEME.SCHEME_STATUS',
    'couponScheme.creationStartDateTime': 'COUPON_SCHEME.CREATION_START_DATE_TIME',
    'couponScheme.creationEndDateTime': 'COUPON_SCHEME.CREATION_END_DATE_TIME',
    'couponScheme.redemptionEndDateTime': 'COUPON_SCHEME.REDEMPTION_END_DATE_TIME',
    'couponScheme.defaultDurationDays': 'COUPON_SCHEME.DEFAULT_DURATION_DAYS',
    'couponScheme.discountValue': 'COUPON_SCHEME.DISCOUNT_VALUE',
    'couponScheme.usageLimitPerCoupon': 'COUPON_SCHEME.USAGE_LIMIT_PER_COUPON',
    'couponScheme.maxCouponsToGenerate': 'COUPON_SCHEME.MAX_COUPONS_TO_GENERATE',
    'couponScheme.sponsor': 'COUPON_SCHEME.SPONSOR',
    'couponScheme.discountArticleEan': 'COUPON_SCHEME.DISCOUNT_ARTICLE_EAN',
    'couponScheme.discountArticleSkuCode': 'COUPON_SCHEME.DISCOUNT_ARTICLE_SKU_CODE',
    'couponScheme.managedBy': 'COUPON_SCHEME.MANAGED_BY',
    'couponToken.id': 'COUPON_TOKEN.ID',
    'couponToken.status': 'COUPON_TOKEN.STATUS',
    'couponToken.dateIssued': 'COUPON_TOKEN.DATE_ISSUED',
    'couponToken.dateExpires': 'COUPON_TOKEN.DATE_EXPIRES',
    'couponToken.usageCount': 'COUPON_TOKEN.USAGE_COUNT',
    'couponToken.usageLimit': 'COUPON_TOKEN.USAGE_LIMIT',
    'couponToken.lastRedeemedOn': 'COUPON_TOKEN.LAST_REDEEMED_ON',
    'couponToken.assignedTo': 'COUPON_TOKEN.ASSIGNED_TO',
    'couponToken.managedBy': 'COUPON_TOKEN.MANAGED_BY',
    'reversalCouponTransaction': 'REVERSAL_COUPON_TRANSACTION',
    'couponTransactionReversal': 'COUPON_TRANSACTION_REVERSAL',
}
